import { render, staticRenderFns } from "./ShipmentMain.vue?vue&type=template&id=22b387fa&scoped=true"
import script from "./ShipmentMain.vue?vue&type=script&lang=js"
export * from "./ShipmentMain.vue?vue&type=script&lang=js"
import style0 from "./ShipmentMain.vue?vue&type=style&index=0&id=22b387fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b387fa",
  null
  
)

export default component.exports